;(function () {
  const globalKey = 'ClorientHeroTextReveal'

  if (window[globalKey]) {
    window[globalKey].init(document)
    return
  }

  const heroSelector = '[data-clorient-hero-animation="true"]'
  const initialDelay = 800
  const lineStagger = 250
  const lineDuration = 600
  const fadeExtraDelay = 200
  const contentFadeDuration = 500
  const instances = new WeakMap()

  const getRoots = (scope) => {
    const roots = []

    if (scope instanceof Element && scope.matches(heroSelector)) {
      roots.push(scope)
    }

    if (scope.querySelectorAll) {
      roots.push(...scope.querySelectorAll(heroSelector))
    }

    return roots
  }

  const initRoot = (root) => {
    if (instances.has(root)) return

    const heading = root.querySelector('.clorient-hero__heading')
    const fadeItems = Array.from(root.querySelectorAll('[data-clorient-hero-fade]'))
    const cardFadeItems = Array.from(root.querySelectorAll('[data-clorient-hero-card-fade]'))
    const timers = new Set()
    const originalAriaLabel = heading ? heading.getAttribute('aria-label') : null
    let observer
    let splitHeading
    let started = false

    const setTimer = (callback, delay) => {
      const timer = window.setTimeout(() => {
        timers.delete(timer)
        callback()
      }, delay)

      timers.add(timer)
      return timer
    }

    const restoreAriaLabel = () => {
      if (!heading) return

      if (originalAriaLabel === null) {
        heading.removeAttribute('aria-label')
      } else {
        heading.setAttribute('aria-label', originalAriaLabel)
      }
    }

    const revertHeading = () => {
      if (!heading) return

      heading.classList.add('clorient-hero__heading--revealed')
      heading.classList.remove('clorient-hero__heading--split')

      if (splitHeading) {
        splitHeading.revert()
        splitHeading = null
      }

      restoreAriaLabel()
    }

    const revealImmediately = () => {
      if (observer) observer.disconnect()
      revertHeading()
      fadeItems.forEach((item) => item.classList.add('clorient-hero__fade--visible'))
      cardFadeItems.forEach((item) => item.classList.add('clorient-hero__fade--visible'))
    }

    const start = () => {
      if (started) return

      started = true
      if (observer) observer.disconnect()

      try {
        if (heading) {
          const accessibleText = (heading.innerText || heading.textContent || '')
            .replace(/\s+/g, ' ')
            .trim()

          if (accessibleText && originalAriaLabel === null) {
            heading.setAttribute('aria-label', accessibleText)
          }

          splitHeading = new window.SplitType(heading, { types: 'lines, words' })
          heading.classList.add('clorient-hero__heading--split')
        }
      } catch (error) {
        console.warn('Clorient hero heading could not be split.', error)
        revealImmediately()
        return
      }

      const lines = heading
        ? Array.from(heading.querySelectorAll('.line'))
        : []

      lines.forEach((line, index) => {
        const animationDelay = initialDelay + index * lineStagger

        Array.from(line.children).forEach((element) => {
          element.style.animationDelay = `${animationDelay / 1000}s`
        })

        line.classList.add('clorient-hero__line--animated')

        setTimer(() => {
          line.style.overflow = 'visible'
        }, animationDelay + lineDuration)
      })

      if (lines.length > 0) {
        const headingEnd = initialDelay + (lines.length - 1) * lineStagger + lineDuration
        setTimer(revertHeading, headingEnd + 50)
      } else {
        revertHeading()
      }

      const fadeDelay = initialDelay + lines.length * lineStagger + fadeExtraDelay
      setTimer(() => {
        fadeItems.forEach((item) => item.classList.add('clorient-hero__fade--visible'))
      }, fadeDelay)

      setTimer(() => {
        cardFadeItems.forEach((item) => item.classList.add('clorient-hero__fade--visible'))
      }, fadeDelay + contentFadeDuration)
    }

    const destroy = () => {
      if (observer) observer.disconnect()
      timers.forEach((timer) => window.clearTimeout(timer))
      timers.clear()
      revealImmediately()
      root.classList.remove('clorient-hero--animation-initialized')
      instances.delete(root)
    }

    instances.set(root, { destroy })
    root.classList.add('clorient-hero--animation-initialized')

    try {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (reduceMotion) {
        revealImmediately()
        return
      }

      if (heading) {
        if (typeof window.SplitType !== 'function') {
          revealImmediately()
          return
        }
      }

      if (typeof window.IntersectionObserver !== 'function') {
        start()
        return
      }

      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          start()
        }
      })

      observer.observe(root.querySelector('.clorient-hero__content') || root)
    } catch (error) {
      console.warn('Clorient hero text animation could not be initialized.', error)
      revealImmediately()
    }
  }

  const init = (scope) => {
    getRoots(scope).forEach(initRoot)
  }

  const destroy = (scope) => {
    getRoots(scope).forEach((root) => {
      const instance = instances.get(root)
      if (instance) instance.destroy()
    })
  }

  window[globalKey] = { init, destroy }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true })
  } else {
    init(document)
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target))
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target))
})()
